import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "max-w-2xl lg:max-w-7xl mx-auto flex flex-col gap-y-16 lg:gap-y-20" }
const _hoisted_2 = {
  key: 0,
  class: "max-w-2xl flex flex-col gap-y-4"
}
const _hoisted_3 = {
  key: 1,
  class: "flex flex-col lg:flex-row lg:items-end gap-8 mx-auto"
}

import { computed } from "vue";
import EditableElement from "@/views/page/EditableElement.vue";
import { CssVarColors } from "@/shared/themes/CssVarColors.interface";
import type { SteppedProps } from "./SteppedProps";
import { PageBlock } from "@/views/blocks/PageBlock.interface";
import Section from "@/views/blocks/shared/section/layout/section/Section.vue";
import FullSpacing from "@/views/blocks/shared/section/layout/spacing/FullSpacing.vue";
import Heading from "@/views/blocks/shared/section/typography/heading/Heading.vue";
import Paragraph from "@/views/blocks/shared/section/typography/paragraph/Paragraph.vue";
import Stat from "./components/Stat.vue";
import type { ScrollAnimationType } from "@/apps/page/page-project.interface";


export default /*@__PURE__*/_defineComponent({
  __name: 'stepped',
  props: {
    block: {},
    pageColors: {},
    scrollAnimationType: {}
  },
  setup(__props: any) {

const props = __props;

const dataValues = computed(() => props.block.dataValues);
const styleValues = computed(() => props.block.styleValues);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Section, {
    id: _ctx.block.webId,
    backgroundColor: styleValues.value.background,
    scrollAnimationType: _ctx.scrollAnimationType
  }, {
    default: _withCtx(() => [
      _createVNode(FullSpacing, null, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            (!dataValues.value.title.isHidden || !dataValues.value.description.isHidden)
              ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                  (!dataValues.value.title.isHidden)
                    ? (_openBlock(), _createBlock(EditableElement, {
                        key: 0,
                        "block-id": _ctx.block.id,
                        "field-name": "title"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(Heading, {
                            text: dataValues.value.title.data.text,
                            tag: dataValues.value.title.data.tag,
                            textColor: styleValues.value.text,
                            class: "text-4xl sm:text-5xl"
                          }, null, 8, ["text", "tag", "textColor"])
                        ]),
                        _: 1
                      }, 8, ["block-id"]))
                    : _createCommentVNode("", true),
                  (!dataValues.value.description.isHidden)
                    ? (_openBlock(), _createBlock(EditableElement, {
                        key: 1,
                        "block-id": _ctx.block.id,
                        "field-name": "description"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(Paragraph, {
                            text: dataValues.value.description.data.text,
                            textColor: styleValues.value.text,
                            class: "opacity-70"
                          }, null, 8, ["text", "textColor"])
                        ]),
                        _: 1
                      }, 8, ["block-id"]))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true),
            (
                        !dataValues.value.firstStat.isHidden ||
                        !dataValues.value.secondStat.isHidden ||
                        !dataValues.value.thirdStat.isHidden
                    )
              ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                  (!dataValues.value.firstStat.isHidden)
                    ? (_openBlock(), _createBlock(EditableElement, {
                        key: 0,
                        "block-id": _ctx.block.id,
                        "field-name": "firstStat"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(Stat, {
                            stat: dataValues.value.firstStat.data.stat,
                            title: dataValues.value.firstStat.data.title,
                            description: dataValues.value.firstStat.data.description,
                            backgroundColor: "#F8FAFC",
                            titleTextColor: "#0F172A",
                            descriptionTextColor: "#0F172A",
                            class: "flex-none lg:w-72 sm:max-w-md sm:w-3/4"
                          }, null, 8, ["stat", "title", "description"])
                        ]),
                        _: 1
                      }, 8, ["block-id"]))
                    : _createCommentVNode("", true),
                  (!dataValues.value.secondStat.isHidden)
                    ? (_openBlock(), _createBlock(EditableElement, {
                        key: 1,
                        "block-id": _ctx.block.id,
                        "field-name": "secondStat"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(Stat, {
                            stat: dataValues.value.secondStat.data.stat,
                            title: dataValues.value.secondStat.data.title,
                            description: dataValues.value.secondStat.data.description,
                            backgroundColor: "#0F172A",
                            titleTextColor: "#ffffff",
                            descriptionTextColor: "#E0E3EB",
                            class: "lg:gap-y-44 w-full lg:max-w-sm"
                          }, null, 8, ["stat", "title", "description"])
                        ]),
                        _: 1
                      }, 8, ["block-id"]))
                    : _createCommentVNode("", true),
                  (!dataValues.value.thirdStat.isHidden)
                    ? (_openBlock(), _createBlock(EditableElement, {
                        key: 2,
                        "block-id": _ctx.block.id,
                        "field-name": "thirdStat"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(Stat, {
                            stat: dataValues.value.thirdStat.data.stat,
                            title: dataValues.value.thirdStat.data.title,
                            description: dataValues.value.thirdStat.data.description,
                            backgroundColor: styleValues.value.brand,
                            titleTextColor: "#ffffff",
                            descriptionTextColor: "#E0E3EB",
                            class: "lg:gap-y-28 w-full sm:max-w-xl"
                          }, null, 8, ["stat", "title", "description", "backgroundColor"])
                        ]),
                        _: 1
                      }, 8, ["block-id"]))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true)
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["id", "backgroundColor", "scrollAnimationType"]))
}
}

})